import React, { Fragment } from "react";
import { connect } from "react-redux";
import RouteTasks from "../components/tasks/RouteTasks";
import RouteTasksSortable from "../components/tasks/RouteTasksSortable";
import CompleteTasks from "../components/tasks/CompleteTasks";
import { getTasksInfo, resetTasksInfo } from "../actions/routeAction";
import Spinner from "../components/layout/Spinner";
import Button from "react-bootstrap/Button";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

class RouteTaskContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: "listView",
    };
  }
  componentDidMount() {
    this.props.getTasksInfo(
      this.props.match ? this.props.match.params.id : this.props.id
    );
  }
  componentWillUnmount() {
    this.props.resetTasksInfo();
  }
  changeDisplay = () => {
    let { display } = this.state;
    this.setState({ display: display === "listView" ? "mapView" : "listView" });
  };

  renderInner(props) {
    let { display } = this.state;

    if (display === "listView") {
      return (
        <div className="container-fluid">
          <Tabs
            className="mt-2"
            id="left-tabs-example"
            defaultActiveKey="tasks"
          >
            <Tab eventKey="tasks" title="Active Tasks">
              <RouteTasks
                tasksInfo={props}
                getTasksInfo={() =>
                  this.props.getTasksInfo(
                    this.props.match
                      ? this.props.match.params.id
                      : this.props.id
                  )
                }
              />
            </Tab>
            <Tab eventKey="complete" title="Completed Tasks">
              <CompleteTasks tasksInfo={props} />
            </Tab>
          </Tabs>
        </div>
      );
    } else if (display === "mapView") {
      return (
        <RouteTasksSortable
          tasksInfo={props}
          user={this.props.user.currentUser}
          getTasksInfo={() =>
            this.props.getTasksInfo(
              this.props.match ? this.props.match.params.id : this.props.id
            )
          }
        />
      );
    }
  }
  render() {
    const { loading, tasksInfo } = this.props.getTasks;
    // console.log(this.props);

    return (
      <div className="pt-5">
        <Button variant="primary" onClick={this.changeDisplay}>
          Toggle to {this.state.display === "listView" ? "mapView" : "listView"}
        </Button>
        {loading ? <Spinner /> : this.renderInner(tasksInfo)}
      </div>
    );
  }
}
const mapStateToProps = ({ getTasks, user }) => ({
  getTasks: getTasks,
  user: user.currentUser,
});
const mapDispatchToProps = (dispatch) => ({
  getTasksInfo: (getTasks) => dispatch(getTasksInfo(getTasks)),
  resetTasksInfo: () => dispatch(resetTasksInfo()),
});
export default connect(mapStateToProps, mapDispatchToProps)(RouteTaskContainer);
